import React, { useEffect, useState } from 'react';
import BonusQrCodeReader from '../../components/Bonus/BonusQrCodeReader';
import bonusAPI from '../../middleware/bonusAPI';
import GuestAmount from '../../components/Bonus/GuestAmount';
import AskUseBonus from '../../components/Bonus/AskUseBonus';
import Swal from 'sweetalert2';
import { trim } from 'lodash';
import { alertError } from '../../Util/Util';
import RewardBonus from '../../components/Bonus/RewardBonus';
import { CircularProgress } from '@material-ui/core';

const Bill = (props) => {
  const { qrcode } = props;
  const [pageStep, setPageStep] = useState('init');
  const [isLoading, setIsLoading] = useState(false);
  const [amount, setAmount] = useState('');
  const [guestMember, setGuestMember] = useState();
  const [rewardBonus, setRewardBonus] = useState();
  const [calculateBonus, setCalculateBonus] = useState();
  const [useBonusResult, setUseBonusResult] = useState();
  const [isUseServiceCharge, setIsUseServiceCharge] = useState(false);
  const [serviceCharge, setServiceCharge] = useState(0);
  const [cancelReScanReturnPage, setCancelReScanReturnPage] = useState();

  useEffect(() => {
    if (calculateBonus) {
      if (calculateBonus.bonusCalculate === 0) {
        setPageStep('addBonus');
      } else {
        setPageStep('useBonus');
      }
    }
  }, [calculateBonus]);

  useEffect(() => {
    if (useBonusResult) {
      setPageStep('addBonus');
    }
  }, [useBonusResult]);

  useEffect(() => {
    if (trim(rewardBonus) !== '') {
      setPageStep('reward');
    }
  }, [rewardBonus]);

  useEffect(() => {
    if (amount) {
      const serviceCharge = Math.round(amount * 0.1);

      setServiceCharge(serviceCharge);
    } else {
      setServiceCharge(0);
    }
  }, [amount]);

  useEffect(() => {
    if (qrcode) {
      verifyQrcodeData(qrcode);
    }
  }, [qrcode]);

  const verifyQrcodeData = (qrcodeData, errorTrigger) => {
    const qrcodeText = trim(qrcodeData);

    setIsLoading(true);

    bonusAPI
      .verifyQrcode(qrcodeText)
      .then(
        (res) => {
          if (!guestMember) {
            setGuestMember({ ...res });
          } else if (guestMember.contact !== res.contact) {
            Swal.fire({
              title: '不同會員無法共用',
              text: '如需要使用別的會員，請回首頁重新操作',
            });
          } else {
            const oldProductInfoList = guestMember.productInfoList
              ? [...guestMember.productInfoList]
              : [];
            const newProductInfoList = res.productInfoList
              ? oldProductInfoList.concat(res.productInfoList)
              : oldProductInfoList;

            setGuestMember({
              ...res,
              productInfoList: newProductInfoList,
            });
          }
        },
        (error) => {
          alertError(error, '無法使用', errorTrigger);
        },
      )
      .then(() => {
        setPageStep(
          cancelReScanReturnPage ? cancelReScanReturnPage : 'checkBonus',
        );
        setIsLoading(false);
      });
  };

  const checkBonus = () => {
    if (trim(amount) === '') {
      Swal.fire({
        icon: 'info',
        title: '請填寫消費金額',
      });

      return false;
    }

    setIsLoading(true);

    bonusAPI
      .calculateBonus(guestMember.contact, amount)
      .then(
        (res) => {
          setCalculateBonus(res);
        },
        (error) => {
          alertError(error, '無法取的可折扣的紅利點數資訊');
        },
      )
      .then(() => {
        setIsLoading(false);
      });
  };

  const addBonus = () => {
    if (trim(amount) === '') {
      Swal.fire({
        icon: 'info',
        title: '請填寫發票金額',
      });

      return false;
    }

    setIsLoading(true);

    const totalAmount = isUseServiceCharge
      ? parseInt(amount, 10) + parseInt(serviceCharge, 10)
      : parseInt(amount, 10);

    bonusAPI
      .accumulatedPoints(guestMember.contact, totalAmount)
      .then(
        (res) => {
          setRewardBonus(res);
        },
        (error) => {
          alertError(error, '增加點數失敗');
        },
      )
      .then(() => {
        setIsLoading(false);
      });
  };

  const bonusUse = () => {
    setIsLoading(true);

    bonusAPI
      .redeemBonus(guestMember.contact, amount, calculateBonus.bonusCalculate)
      .then(
        (res) => {
          setAmount(
            parseInt(amount, 10) - parseInt(calculateBonus.bonusCalculate, 10),
          );
          setUseBonusResult({
            use: calculateBonus.bonusCalculate,
            remaining: res,
          });
        },
        (error) => {
          alertError(error, '折扣紅利點數失敗');
        },
      )
      .then(() => {
        setIsLoading(false);
      });
  };

  const bonusNoUse = () => {
    setPageStep('addBonus');
  };

  const switchServiceCharge = () => {
    setIsUseServiceCharge(!isUseServiceCharge);
  };

  const reScanQrcode = () => {
    setCancelReScanReturnPage(pageStep);
    setPageStep('scanQrcode');
  };

  const cancelReScanQrcode = () => {
    setPageStep(cancelReScanReturnPage);
  };

  return (
    <div className="bonus">
      {pageStep === 'init' && (
        <div>
          <CircularProgress />
          <div>讀取中</div>
        </div>
      )}

      {pageStep === 'scanQrcode' && (
        <BonusQrCodeReader
          verifyQrcodeData={verifyQrcodeData}
          cancelReScanQrcode={guestMember ? cancelReScanQrcode : undefined}
          isLoading={isLoading}
        />
      )}

      {((pageStep === 'checkBonus' && guestMember) ||
        pageStep === 'addBonus') && (
        <GuestAmount
          guestMember={guestMember}
          amount={amount}
          setAmount={setAmount}
          checkBonus={checkBonus}
          addBonus={addBonus}
          isLoading={isLoading}
          pageStep={pageStep}
          useBonusResult={useBonusResult}
          calculateBonus={calculateBonus}
          serviceCharge={serviceCharge}
          isUseServiceCharge={isUseServiceCharge}
          switchServiceCharge={switchServiceCharge}
          reScanQrcode={reScanQrcode}
        />
      )}

      {pageStep === 'useBonus' && (
        <AskUseBonus
          guestMember={guestMember}
          calculateBonus={calculateBonus}
          amount={amount}
          bonusUse={bonusUse}
          bonusNoUse={bonusNoUse}
          isLoading={isLoading}
        />
      )}

      {pageStep === 'reward' && <RewardBonus rewardBonus={rewardBonus} />}
    </div>
  );
};

export default Bill;
